<template>
  <div>
    <v-progress-circular v-if="loading" indeterminate color="primary" />
    <add-new-user-guide
      :info="info"
      @fetch="complete"
      @close="handleclsoe"
      :name="name"
      :isEdit="true"
    />
  </div>
</template>

<script>
import AddNewUserGuide from "./addNewUserGuide.vue";

export default {
  name: "editUserGuide",

  components: { AddNewUserGuide },
  props: {
    guideId: { type: [String, Number], default: null },
    isPopup: { type: Boolean, default: false },
    name: { type: String, default: "" },
  },
  data: () => ({
    info: {},
    loading: false,
  }),

  mounted() {
    this.getGuide();
  },

  computed: {
    updateId() {
      return this.$route.params?.id?.replace('?gateway=true','') || this.guideId;
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    handleclsoe() {
      if (this.isPopup) {
        $emit("close");
      }
    },
    getGuide() {
      if (!this.updateId) {
        this.$toast.error(this.$t("error_not_valid_guide_id"));
        return;
      }
      this.loading = true;
      this.requestApiGetCore2(`guideContent/show/${this.updateId}`)
        .then(({ data }) => {
          const guide = data.data;
          if (typeof guide.extras === "string") {
            guide.extras = JSON.parse(guide.extras);
          }
          if (!guide.extras) {
            guide.extras = {
              qa: [{ question: "", answer: "" }],
              images: [{ name: "", images: [] }],
              videos: [{ name: "", images: [] }],
              audio: [],
              others: [],
            };
          }
          if (!guide.extras.videos) {
            guide.extras.videos = [{ name: "", images: [] }];
          }
          this.info = { ...guide };
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || this.$t("error_give_guide_info"),
          );
        })
        .finally(() => (this.loading = false));
    },
    complete(data) {
      this.loading = true;

      let qa = data.extras.qa.filter((item) => !!item.question);
      data.extras = JSON.stringify({
        ...data.extras,
        qa,
      });
      const result = data;
      this.requestApiPostCore2(`guideContent/update/${this.updateId}`, data)
        .then(({ data }) => {
          this.$toast.info(this.$t("info_success_saved"));
          console.log("با موفقیت ذخیره شد.");

          if (this.isPopup) {
            this.$emit("fetch");
            this.$emit("close");
          } else {
            // this.$router.push({
            //   path: "/content",
            //   query: { tabs: 2, sid: result.service_id },
            // });
          }
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || this.$t("error_add_new_guide"),
          );
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
